import moment from 'moment';
import queryApi from './api/queryApi';
import axios from 'axios';
import config from '../config';
/* ACTIONS */

/* ROUTE API */
const INSPECTIONTIME_UPDATE = '/INSPECTIONTIME_UPDATE';
const INVERTER_DATA = 'INVERTER_DATA';
const USER_STATION = 'USER_STATION';
const STATION_SUMMARY = 'STATION_SUMMARY';
const INVERTER_LIST = 'INVERTER_LIST';
const INVERTER_SUMMARY = 'INVERTER_SUMMARY';
const ANALYSIS_USAGE = 'ANALYSIS_USAGE';

const FINANCE_SET = 'FINANCE_SET';
const FINANCE_DELETE = 'FINANCE_DELETE';

const HIDDEN_STATION_PATTERNS = [
  /^皇冠豪苑\d+号别墅$/,
];

const INVERTER_DATA_CACHE = 'INVERTER_DATA_CACHE';
const ANALYSIS_USAGE_CACHE = 'ANALYSIS_USAGE_CACHE';

const initialState = {
  inspectionTime: { range: 'd', date: moment().toISOString(), stationInfo: {} },
  inverterData: [],
  inverterDataCache: {},
  inverterList: {},
  userStationList: [],
  stationSummary: {},
  inverterSummary: {},
  financeByMonth: {},
  usageBySiteDate: {},
  usageDataCache: {}, // Added this line
};

export default (state = initialState, action) => {
  switch (action.type) {
    case INSPECTIONTIME_UPDATE:
      return {
        ...state,
        inspectionTime: action.payload,
      };
    case INVERTER_DATA:
      return {
        ...state,
        inverterData: action.payload,
      };
    case INVERTER_DATA_CACHE:
      return {
        ...state,
        inverterDataCache: {
          ...state.inverterDataCache,
          [action.payload.key]: action.payload.data,
        },
      };
    case INVERTER_LIST:
      return {
        ...state,
        inverterList: {
          ...state.inverterList,
          ...action.payload,
        },
      };
    case USER_STATION:
      return {
        ...state,
        userStationList: action.payload,
      };
    case STATION_SUMMARY:
      return {
        ...state,
        stationSummary: {
          ...state.stationSummary,
          ...action.payload,
        },
      };
    case INVERTER_SUMMARY: {
      const { stationId, inverterId, data } = action.payload;
      return {
        ...state,
        inverterSummary: {
          ...state.inverterSummary,
          [stationId]: {
            ...(state.inverterSummary[stationId] || {}),
            [inverterId]: data,
          },
        },
      };
    }
    case FINANCE_SET: {
      const { stationId, reportMonth, data } = action.payload;
      return {
        ...state,
        financeByMonth: {
          ...state.financeByMonth,
          [stationId]: {
            ...(state.financeByMonth[stationId] || {}),
            [reportMonth]: data,
          },
        },
      };
    }
    case FINANCE_DELETE: {
      const { stationId, reportMonth } = action.payload;
      const stationMap = { ...(state.financeByMonth[stationId] || {}) };
      delete stationMap[reportMonth];
      return {
        ...state,
        financeByMonth: {
          ...state.financeByMonth,
          [stationId]: stationMap,
        },
      };
    }
    case ANALYSIS_USAGE: {
      const { stationId, dateKey, data } = action.payload;
      return {
        ...state,
        usageBySiteDate: {
          ...state.usageBySiteDate,
          [stationId]: {
            ...(state.usageBySiteDate[stationId] || {}),
            [dateKey]: data,
          },
        },
      };
    }
    case ANALYSIS_USAGE_CACHE: { // Added this case
      const { key, data } = action.payload;
      return {
        ...state,
        usageDataCache: {
          ...state.usageDataCache,
          [key]: data,
        },
      };
    }
    default:
      return state;
  }
};

export const inspectionTimeUpdate = (data) => {
  return (dispatch, getState) => {
    const state = getState ? getState() : null;
    const previous = state?.analytics?.inspectionTime || {};
    const payload = {
      ...previous,
      ...(data || {}),
    };
    dispatch({
      type: INSPECTIONTIME_UPDATE,
      payload,
    });
  };
};


export const getInverterData = (query) => {
  return (dispatch, getState) => {
    let qs = '';
    const normalizeParams = (sp) => {
      const range = sp.get('range');
      const dateValue = sp.get('date');

      if (dateValue && (range === 'm' || range === 'y')) {
        const dateMoment = moment(dateValue);
        if (dateMoment.isValid()) {
          if (range === 'm') {
            dateMoment.startOf('month');
          } else if (range === 'y') {
            dateMoment.startOf('year');
          }
          sp.set('date', dateMoment.format('YYYY-MM-DD'));
        }
      }

      return sp.toString();
    };

    try {
      if (typeof query === 'string') {
        const sp = new URLSearchParams(query);
        qs = normalizeParams(sp); // ensures values like NE=335... become NE%3D335...
      } else if (query && typeof query === 'object') {
        const sp = new URLSearchParams();
        Object.entries(query).forEach(([k, v]) => {
          if (v !== undefined && v !== null) sp.append(k, String(v));
        });
        qs = normalizeParams(sp);
      }
    } catch (e) {
      qs = String(query || '');
    }

    const cache = getState().analytics.inverterDataCache || {};
    if (cache[qs]) {
      dispatch({ type: INVERTER_DATA, payload: cache[qs] });
      return Promise.resolve(cache[qs]);
    }

    return queryApi
      .get(`data/inverterDay?${qs}`)
      .then((data) => {
        dispatch({ type: INVERTER_DATA, payload: data });
        dispatch({ type: INVERTER_DATA_CACHE, payload: { key: qs, data } });
        return data;
      })
      .catch((error) => { throw error; });
  };
};

export const getUserStationList = (force = false) => {
  return (dispatch, getState) => {
    const existing = getState().analytics.userStationList;
    if (!force && Array.isArray(existing) && existing.length > 0) {
      return Promise.resolve(existing);
    }
    return queryApi
      .get(`data/userStationList`)
      .then((data) => {
        const filtered = Array.isArray(data)
          ? data.filter((station) => {
            const name = (station.stationName || '').trim();
            return !HIDDEN_STATION_PATTERNS.some((pattern) => pattern.test(name));
          })
          : [];
        dispatch({
          type: USER_STATION,
          payload: filtered,
        });
        return filtered;
      })
      .catch((error) => {
        throw error;
      });
  };
};

export const getStationSummary = (stationId, force = false) => {
  return (dispatch, getState) => {
    const cache = getState().analytics.stationSummary || {};
    if (!force && cache[stationId]) {
      return Promise.resolve(cache[stationId]);
    }
    return queryApi
      .get(`data/stationSummary?stationId=${encodeURIComponent(stationId)}`)
      .then((data) => {
        dispatch({
          type: STATION_SUMMARY,
          payload: { [stationId]: data },
        });
        return data;
      })
      .catch((error) => {
        throw error;
      });
  };
};

export const getInverterSummary = (stationId, inverterId, force = false) => {
  return (dispatch, getState) => {
    const cache = getState().analytics.inverterSummary || {};
    if (!force && cache[stationId] && cache[stationId][inverterId]) {
      return Promise.resolve(cache[stationId][inverterId]);
    }
    return queryApi
      .get(`data/stationSummary?stationId=${encodeURIComponent(stationId)}&inverterId=${encodeURIComponent(inverterId)}`)
      .then((data) => {
        dispatch({
          type: INVERTER_SUMMARY,
          payload: { stationId, inverterId, data },
        });
        return data;
      })
      .catch((error) => {
        throw error;
      });
  };
};

export const getInverterList = (stationId, force = false) => {
  return (dispatch, getState) => {
    const cache = getState().analytics.inverterList || {};
    if (!force && cache[stationId]) {
      return Promise.resolve(cache[stationId]);
    }
    return queryApi
      .get(`data/inverterList?stationId=${encodeURIComponent(stationId)}`)
      .then((data) => {
        dispatch({
          type: INVERTER_LIST,
          payload: { [stationId]: data },
        });
        return data;
      })
      .catch((error) => {
        throw error;
      });
  };
};

export const updateUserStation = (payload) => {
  return dispatch => {
    return queryApi.patch(`data/userStation`, payload)
      .then((data) => data)
      .catch(error => { throw (error); });
  };
};

// Fetch summaries for multiple stations and cache them in redux
export const fetchStationsSummaryList = (ids = [], force = false) => {
  return async (dispatch, getState) => {
    const cache = getState().analytics.stationSummary || {};
    const toFetch = ids.filter((id) => force || !cache[id]);
    if (toFetch.length === 0) {
      return Promise.resolve(cache);
    }
    const results = await Promise.all(
      toFetch.map((id) =>
        queryApi
          .get(`data/stationSummary?stationId=${encodeURIComponent(id)}`)
          .then((data) => [id, data])
      )
    );
    const payload = {};
    results.forEach(([id, data]) => {
      payload[id] = data;
    });
    dispatch({
      type: STATION_SUMMARY,
      payload,
    });
    return { ...cache, ...payload };
  };
};

export const getFinanceByStationMonth = (stationId, reportMonth, force = false) => {
  return (dispatch, getState) => {
    const cache = getState().analytics.financeByMonth || {};
    if (!force && cache[stationId] && cache[stationId][reportMonth]) {
      return Promise.resolve(cache[stationId][reportMonth]);
    }
    return queryApi
      .get(`finance/${encodeURIComponent(stationId)}/${encodeURIComponent(reportMonth)}`)
      .then((data) => {
        dispatch({ type: FINANCE_SET, payload: { stationId, reportMonth, data } });
        return data;
      })
      .catch((error) => { throw error; });
  };
};

export const getUsageBySiteDate = (stationId, date, force = false, meterType) => {
  return (dispatch, getState) => {
    const dateKey = moment(date).format('YYYY-MM-DD');
    const typeKey = meterType ? `_${meterType}` : '';
    const cacheKey = `${stationId}_${dateKey}${typeKey}`;
    const cache = getState().analytics.usageDataCache || {};

    if (!force && cache[cacheKey]) {
      dispatch({
        type: ANALYSIS_USAGE,
        payload: { stationId, dateKey, data: cache[cacheKey] },
      });
      return Promise.resolve(cache[cacheKey]);
    }

    const params = new URLSearchParams({ siteId: stationId, date: dateKey });
    if (meterType) params.append('type', meterType);

    return queryApi
      .get(`analysis/usage?${params.toString()}`)
      .then((data) => {
        dispatch({
          type: ANALYSIS_USAGE,
          payload: { stationId, dateKey, data },
        });
        dispatch({
          type: ANALYSIS_USAGE_CACHE,
          payload: { key: cacheKey, data },
        });
        return data;
      })
      .catch((error) => {
        throw error;
      });
  };
};

export const upsertFinanceByStationMonth = (stationId, reportMonth, payload) => {
  return (dispatch) => {
    return axios
      .patch(`${config.api}finance/${encodeURIComponent(stationId)}/${encodeURIComponent(reportMonth)}`, payload, {
        headers: { 'Content-Type': 'application/json' }
      })
      .then((res) => res.data)
      .then((data) => {
        dispatch({ type: FINANCE_SET, payload: { stationId, reportMonth, data } });
        return data;
      })
      .catch((error) => { throw error; });
  };
};

export const updateFinanceById = (stationId, reportMonth, financeId, payload) => {
  return (dispatch) => {
    return queryApi
      .patch(`finance/${encodeURIComponent(financeId)}`, payload)
      .then((data) => {
        const sid = data?.stationId || stationId;
        const mon = data?.reportMonth || reportMonth;
        dispatch({ type: FINANCE_SET, payload: { stationId: sid, reportMonth: mon, data } });
        return data;
      })
      .catch((error) => { throw error; });
  };
};

export const removeFinanceById = (stationId, reportMonth, financeId) => {
  return (dispatch) => {
    return queryApi
      .delete(`finance/${encodeURIComponent(financeId)}`)
      .then(() => {
        dispatch({ type: FINANCE_DELETE, payload: { stationId, reportMonth } });
      })
      .catch((error) => { throw error; });
  };
};

export const uploadFinanceReport = (stationId, reportMonth, file, type = 'generic') => {
  return async () => {
    const form = new FormData();
    form.append('file', file);
    const url = `${config.api}finance/${encodeURIComponent(stationId)}/${encodeURIComponent(reportMonth)}/report` + (type ? `?type=${encodeURIComponent(type)}` : '');
    const res = await axios.post(url, form, { headers: { 'Content-Type': 'multipart/form-data' } });
    return res.data;
  };
};

// src/modules/analytics.js
export const downloadFinanceReport = (stationId, reportMonth, type = '') => {
  return async () => {
    const url = `${config.api}finance/${encodeURIComponent(stationId)}/${encodeURIComponent(reportMonth)}/report`
      + (type ? `?type=${encodeURIComponent(type)}` : '');
    const token = localStorage.getItem('jwt') || localStorage.getItem('token') || localStorage.getItem('authToken');
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    const res = await axios.get(url, { responseType: 'blob', headers });

    let filename = '';
    const cd = res.headers && (res.headers['content-disposition'] || res.headers['Content-Disposition']);
    if (cd) {
      const m = /filename\*=UTF-8''([^;]+)|filename=\"?([^\";]+)\"?/i.exec(cd);
      filename = decodeURIComponent((m && (m[1] || m[2])) || '');
    }
    return { blob: res.data, filename };
  };
};
